import { Plan, PlanCategory } from '@/shared/types/Billing';

export const isBusiness250Plan = (plan: Pick<Plan, 'category' | 'metadata'> | undefined): boolean =>
  plan?.category === PlanCategory.Business && Number(plan.metadata.bundle_value) === 250;
